import { render, staticRenderFns } from "./ShippingItem.vue?vue&type=template&id=20ecae64&scoped=true&"
import script from "./ShippingItem.vue?vue&type=script&lang=js&"
export * from "./ShippingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecae64",
  null
  
)

export default component.exports